import styled from 'styled-components'
import FormControl from '@material-ui/core/FormControl'
import colors from 'Assets/colors'
import { media } from 'Config/styled'

export const ModalContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0%;
  left: ${props => (props.left ? props.left : '0%')};
  right: ${props => (props.right ? props.right : 'unset')};
  z-index: 200;
  background-color: ${colors.white};
  padding: ${props => (props.range === 'false' ? '0' : '24px 40px')};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 3px;
  width: ${props => (props.range === 'false' ? 'auto' : '800px')};
  display: ${props => (props.range === 'false' ? 'block' : 'grid')};
  grid-template-columns: 48% 48%;
  grid-column-gap: 4%;

  ${media('lg')} {
    grid-template-columns: 1fr;
    width: 100%;
  }
`

export const ModalItem = styled.div`
  display: ${props => (props.range === 'false' ? 'none' : 'block')};
`

export const SubLabel = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
  text-align: left;
  margin-bottom: 8px;
  display: ${props => (props.range === 'false' ? 'none' : 'block')};
`

export const Container = styled(FormControl)`
  position: relative;
  width: 100%;

  .MuiFormControl-fullWidth {
    height: ${props => (props.height ? props.height : '56px')};
  }
  .MuiFilledInput-underline:before {
    border-bottom: none;
  }
  .MuiFilledInput-root {
    background-color: ${colors.white};
  }
  .MuiFilledInput-root:hover {
    background-color: ${colors.white};
  }
  .MuiFilledInput-underline:hover:before {
    border-bottom: none;
  }
  .MuiFilledInput-underline:after {
    border-bottom: none;
  }
  .MuiFilledInput-input {
    padding: 0 15px;
    height: ${props => (props.height ? props.height : '56px')};
  }
  .MuiFilledInput-input::placeholder {
    color: ${colors.gray40l};
    opacity: 0.8;
  }
  .MuiFilledInput-root {
    background-color: #f4f1f1;
    border-radius: 8px;
    height: ${props => (props.height ? props.height : '56px')};
    border: ${props => props.border};
  }
  .MuiFilledInput-root:hover {
    background-color: #f4f1f1;
    border-radius: 8px;
    transition: all 0.2s;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0), 0px 0px 2px rgba(0, 0, 0, 0);
  }
  .MuiFilledInput-root.Mui-focused {
    background: white;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
    .MuiInputAdornment-root {
      path {
        fill: ${colors.secondary};
      }
    }
  }
  .MuiInputAdornment-root {
    margin-right: 4px;
    display: ${props => (props.showIcon ? props.showIcon : null)};
  }

  .searchCalendar .react-calendar__tile--active.react-calendar__tile--rangeStart abbr {
    border-radius: 0px !important;
    margin: 0;
    width: 100%;
  }
`
